import EditScaleContainer from "./EditScaleContainer";
export default EditScaleContainer;
